import React from 'react'
import CreateVisitorForm from '../components/visitor/createVisitor/createVisitorForm';
import { hasPermission } from '../components/auth/login/Login';
import { useNavigate } from 'react-router-dom';

function CreateVisitor() {
    const canCreateVisitor = hasPermission("Visitors", "Visitor", "create");
    const navigate = useNavigate();

    if (!canCreateVisitor) {
        navigate('/no-permission')
    }

    return (
        <CreateVisitorForm />
    )
}

export default CreateVisitor